import { Page } from "../types/Types";

interface ControlBarProps {
  gridOrig: string[][];
  move: number;
  gameStopped: boolean;
  setCurrentPage: (currentPage: Page) => void;
  setMove: (move: number) => void;
  setGrid: (grid: string[][]) => void;
}

const ControlBar: React.FC<ControlBarProps> = ({
  gridOrig,
  move,
  gameStopped,
  setCurrentPage,
  setMove,
  setGrid
}) => {
  return ( 
    <div className="font-bold text-3xl py-3 my-3 justify-between flex flex-row w-full items-center">
      <svg className="cursor-pointer" onClick={() => setCurrentPage('home')} width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807612 11.0711 0.807612 10.4853 1.3934L0.93934 10.9393ZM22 10.5L2 10.5V13.5L22 13.5V10.5Z" fill="black" />
      </svg>
      {move !== 0 && !gameStopped && (
        <svg className="cursor-pointer" onClick={() => { setMove(0); setGrid(gridOrig) }} width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.2857 0V2.71429H2.71429C1.22143 2.71429 0 3.93571 0 5.42857V8.14286H2.71429V5.42857H16.2857V8.14286L21.7143 4.07143L16.2857 0ZM5.42857 10.8571L0 14.9286L5.42857 19V16.2857H19C20.4929 16.2857 21.7143 15.0643 21.7143 13.5714V10.8571H19V13.5714H5.42857V10.8571Z" fill="black" />
        </svg>
      )}
    </div>
  );
}
 
export default ControlBar;
